<template>
  <v-dialog
    persistent
    v-model="dialog"
    @keydown.esc="dialog = false"
    width="850"
    scrollable
  >
    <v-form ref="form" @submit.prevent lazy-validation v-model="valid">
      <v-card class="elevation-3">
        <v-card-title class="primary text-h5 white--text">
          {{ modalText }}
        </v-card-title>
        <v-card-text class="pa-4">
          <v-row>
            <v-col sm="12">
              <v-text-field
                label="Issue Number"
                v-model="selectedLuExciseIssues.IssueNumber"
                type="number"
                :rules="[(v) => !!v || 'required']"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <v-text-field
                label="Description"
                v-model="selectedLuExciseIssues.Description"
                :rules="[(v) => !!v || 'required']"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <v-text-field
                label="Statute"
                v-model="selectedLuExciseIssues.Statute"
                :rules="[(v) => !!v || 'required']"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <v-text-field
                label="Rules Reg"
                v-model="selectedLuExciseIssues.RulesReg"
                :rules="[(v) => !!v || 'required']"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <v-checkbox
                label="Subject To Interest"
                v-model="selectedLuExciseIssues.SubjectToInterest"
                :rules="[(v) => v === true || v === false || 'required']"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <v-checkbox
                label="Is Active"
                v-model="selectedLuExciseIssues.IsActive"
                :rules="[(v) => v === true || v === false || 'required']"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            @click="saveLuExciseIssuesDetails"
            :disabled="saving"
            color="primary"
            >Save</v-btn
          >
          <v-btn outlined color="primary" @click="cancelEntry">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import {get, sync, commit, call} from 'vuex-pathify'
import LuExciseIssues from '@classes/LuExciseIssues'
//templateTODO: import lookup components you plan to use
export default {
  components: {
    //templateTodo: define lookup components you are using
  },
  data: () => ({
    dialog: false,
    valid: true,
    selectedLuExciseIssues: new LuExciseIssues(),
    modalText: '',
  }),
  created() {},
  computed: {
    ...get('luExciseIssues', ['saving']),
  },
  methods: {
    handleError: call('errors/handleError'),
    ...call('luExciseIssues', ['saveLuExciseIssues']),
    async validate() {
      this.$refs.form.validate()
    },
    editLuExciseIssues(entry) {
      this.selectedLuExciseIssues = new LuExciseIssues(entry)
      this.modalText = 'Edit Issues'
      this.dialog = !this.dialog
    },
    addLuExciseIssues() {
      this.modalText = 'Insert Issues'
      this.selectedLuExciseIssues = new LuExciseIssues()
      this.dialog = !this.dialog
    },
    saveLuExciseIssuesDetails() {
      this.validate().then(() => {
        if (this.valid) {
          //templateTODO: if you want to save related item arrays you will need to add a getSaveData() function to the javascript class and call that instead
          this.saveLuExciseIssues(
            this.selectedLuExciseIssues.removeRelated()
          ).then(
            (res) => {
              this.$emit('refresh')
              this.selectedLuExciseIssues = new LuExciseIssues()
              this.$refs.form.resetValidation()
            },
            (err) => {}
          )
          this.dialog = false
        }
      })
    },
    cancelEntry() {
      this.dialog = false
      this.selectedLuExciseIssues = new LuExciseIssues()
      this.$refs.form.resetValidation()
    },
  },
}
</script>
<style></style>
